import { registerAction } from '../../Action'
import { workflowActions } from '../workflowActions'

const duplicateWorkflowForContextAction = registerAction(
  workflowActions.DUPLICATE_WORKFLOW_FOR_CONTEXT,
  { reducer: null }
)

export default duplicateWorkflowForContextAction
